import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import { FaCheck, FaTimes } from 'react-icons/fa';
import axios from '../utils/axios';

function Plans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axios.get('/plans');
        setPlans(response.data);
        setLoading(false);
      } catch (error) {
        toast.error('Failed to fetch plans');
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const handleSubscribe = async (planId) => {
    if (!user) {
      toast.error('Please login to subscribe');
      navigate('/login');
      return;
    }

    try {
      const response = await axios.post('/subscriptions/create-checkout-session', {
        planId
      });

      const { url } = response.data;
      window.location.href = url;
    } catch (error) {
      toast.error('Failed to initiate subscription');
    }
  };

  if (loading) {
    return <div className="loading">Loading plans...</div>;
  }

  return (
    <div className="plans-container">
      <h1>Choose Your Plan</h1>
      <div className="plans-grid">
        {plans.map((plan) => (
          <div key={plan._id} className="plan-card">
            <h2>{plan.name}</h2>
            <div className="price">
              ${plan.price}
              <span>/month</span>
            </div>
            <ul className="features">
              {plan.features.map((feature, index) => (
                <li key={index}>
                  {feature.included ? <FaCheck className="check" /> : <FaTimes className="times" />}
                  {feature.name}
                </li>
              ))}
            </ul>
            <button
              className="btn btn-block"
              onClick={() => handleSubscribe(plan._id)}
            >
              Subscribe Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Plans; 